export class Regional {

    public id: string = "0";
    public name: string;
    public short: string;
    
    public deleted: boolean=false;

    constructor() {}
}